import { useEffect, useState } from "react"
import Shoot from "./shoot"
import ToothSelector from "./toothSelector"
import { useNavigate } from "react-router-dom"
import { useSelector } from "react-redux"
import { generateSteps } from "./steps";

const Scan = () => {
    console.log("called console scan review insurance")
    const navigate = useNavigate()
    const { images } = useSelector((state) => state.fullScan);
    const [isToothPicker, setToothPicker] = useState(false)
    const activeSteps = JSON.parse(localStorage.getItem("activeCaptureSteps") || "{}");
    const hasFaceStep = activeSteps?.face === true;
    const [activeImageSide, setImageSide] = useState(hasFaceStep ? -1 : 0);

    useEffect(() => {
        console.log(images.length, generateSteps("front").length, generateSteps("front"), "tttt")
        if (!localStorage.getItem("usertpi") || localStorage.getItem("isScanCompleted")) {
            navigate(`/${localStorage.getItem("company")}/${localStorage.getItem("cameraSide")}`)
        }
        if (images.length == generateSteps("front").length) {
            setToothPicker(true)
        }

    }, [activeImageSide])




    return (
        <div className="h-full">
            {
                isToothPicker ?
                    <ToothSelector setImageSide={setImageSide} setToothPicker={setToothPicker} /> :
                    <Shoot activeImageSide={activeImageSide} setToothPicker={setToothPicker} quickScan={false} setImageSide={setImageSide} />
            }
        </div>
    )
}

export default Scan